import classNames from "classnames";
import PropTypes from "prop-types";

export const Header2 = ({ children, classes }) => {
  return <h2 className={classNames("header-h2", classes)}>{children}</h2>;
};

Header2.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.string,
};
